import { render } from "./VoucherCartPage.vue?vue&type=template&id=5af4b564&scoped=true"
import script from "./VoucherCartPage.vue?vue&type=script&lang=js"
export * from "./VoucherCartPage.vue?vue&type=script&lang=js"

import "./VoucherCartPage.vue?vue&type=style&index=0&id=5af4b564&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af4b564"]])

export default __exports__